"use strict";
exports.__esModule = true;
exports.TextToken = void 0;
var TextToken;
(function (TextToken) {
    TextToken["DISPLAY_LARGE"] = "displayLarge";
    TextToken["DISPLAY_MEDIUM"] = "displayMedium";
    TextToken["HEADING_EXTRA_LARGE"] = "headingExtraLarge";
    TextToken["HEADING_LARGE"] = "headingLarge";
    TextToken["HEADING_MEDIUM"] = "headingMedium";
    TextToken["HEADING_SMALL"] = "headingSmall";
    TextToken["BUTTON_EXTRA_LARGE"] = "buttonExtraLarge";
    TextToken["BUTTON_LARGE"] = "buttonLarge";
    TextToken["BUTTON_MEDIUM"] = "buttonMedium";
    TextToken["BUTTON_SMALL"] = "buttonSmall";
    TextToken["BUTTON_EXTRA_SMALL"] = "buttonExtraSmall";
    TextToken["LABEL_EXTRA_LARGE"] = "labelExtraLarge";
    TextToken["LABEL_LARGE"] = "labelLarge";
    TextToken["LABEL_MEDIUM"] = "labelMedium";
    TextToken["LABEL_SMALL"] = "labelSmall";
    TextToken["LABEL_EXTRA_SMALL"] = "labelExtraSmall";
    TextToken["PARAGRAPH_EXTRA_LARGE"] = "paragraphExtraLarge";
    TextToken["PARAGRAPH_LARGE"] = "paragraphLarge";
    TextToken["PARAGRAPH_MEDIUM"] = "paragraphMedium";
    TextToken["PARAGRAPH_SMALL"] = "paragraphSmall";
})(TextToken = exports.TextToken || (exports.TextToken = {}));
